import { Swiper, Navigation, Pagination } from "swiper";

const swiper = new Swiper('#hero-slider', {
    modules: [Navigation, Pagination],
    speed: 400,
    spaceBetween: 0,
    autoplay: {
        delay: 5000,
    },
    pagination:{
        el: '.swiper-pagination',
        type: 'bullets',
      },
    loop: true
});